import { createChoiceStorage } from '@/Groups/Portfolios/private/utils/choiceStorage';

const storage = createChoiceStorage({ key: 'portfolios_period', allowed: ['d7', 'd30'], fallback: 'd7' });

export const periodStorage = {
  //Сохранить выбранный период
  setPeriod: storage.set,
  //Прочитать период
  getPeriod: storage.get,
};
